import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = { data: Array, labels: Array, colors: Array }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    // Softer, more elegant colors
    const colors = this.hasColorsValue ? this.colorsValue : ['#34d399', '#60a5fa', '#f87171']

    const options = {
      chart: {
        type: 'donut',
        toolbar: { show: false },
        height: '80%',  // Make the whole chart smaller (proportional)
        width: '80%',
        parentHeightOffset: 0
      },
      colors: colors,
      series: this.dataValue,
      labels: this.labelsValue,
      plotOptions: {
        pie: {
          donut: {
            size: '45%',  // Thicker ring - LOWER percentage = BIGGER hole = THICKER ring
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '12px',
                fontWeight: 500,
                color: '#9ca3af',
                offsetY: -10
              },
              value: {
                show: true,
                fontSize: '24px',
                fontWeight: 700,
                color: '#6b7280',  // Gray instead of black
                offsetY: 5,
                formatter: function(val) {
                  return val
                }
              },
              total: {
                show: true,
                showAlways: true,
                label: 'Total',
                fontSize: '12px',
                fontWeight: 600,
                color: '#9ca3af',
                formatter: function(w) {
                  return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                }
              }
            }
          },
          expandOnClick: false,
          customScale: 1,
          offsetX: 0,
          offsetY: 0
        }
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        distributed: false,
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: '15px',
          fontWeight: 700,  // Bold for number
          colors: ['#fff']
        },
        background: {
          enabled: false
        },
        dropShadow: {
          enabled: false
        },
        formatter: function(val, opts) {
          const value = opts.w.config.series[opts.seriesIndex]
          const percentage = Math.round(val)  // Remove decimals
          // Array creates line breaks - just value and percentage, no spacing
          return [value, percentage + '%']
        }
      },
      legend: {
        position: 'bottom',  // Changed from 'right' to 'bottom'
        fontSize: '13px',
        fontWeight: 500,
        offsetY: 0,
        horizontalAlign: 'center',
        markers: {
          width: 10,
          height: 10,
          radius: 2
        },
        itemMargin: {
          horizontal: 10,
          vertical: 5
        },
        formatter: function(seriesName) {
          return seriesName
        }
      },
      states: {
        hover: {
          filter: {
            type: 'none'  // Disable hover effects
          }
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none'
          }
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['#fff']
      },
      tooltip: {
        enabled: false  // Disable tooltip completely (no hover info)
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
